import React from "react";
import './style.less'
import {Tabs} from 'antd';

const {TabPane} = Tabs;

export default class GimbalVideoContent extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="gimbal-video-container">
                <div className={"content"}>
                    <Tabs tabPosition={this.props.isMobile ? "top" : "left"}>
                        <TabPane tab="30 倍高清无损变焦" key="1">
                            <div className="video-container video">
                                <video src="http://qiniu.metridynamic.com/video/new%20video/20220424-134341.mp4"
                                       autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="星光红外融合显示" key="2">
                            <div className="video-container video">
                                <video src="https://qiniu.metridynamic.com/video/cn/%E5%90%8A%E8%88%B1%E7%83%AD%E6%88%90%E5%83%8F%E5%92%8C%E6%97%A5%E5%85%89%E7%9B%B8%E6%9C%BA%E8%9E%8D%E5%90%88%E8%8B%B1%E6%96%87%E7%89%88_x264.mp4" autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="热成像" key="3">
                            <div className="video-container video">
                                <video src="http://qiniu.metridynamic.com/video/thermalImagery.mp4" autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="智能跟踪" key="4">
                            <div className="video-container video">
                                <video src="http://qiniu.metridynamic.com/video/new%20video/20220424-134338.mp4"
                                       autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                        <TabPane tab="吊舱视角和目标位置实时显示" key="5">
                            <div className="video-container video">
                                <video
                                    src="http://qiniu.metridynamic.com/video%2Fnew%20video%2Fpayload%2F%E9%A3%9E%E4%B9%A620220512-094403.mp4"
                                    autoPlay loop muted>
                                </video>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )

    }
}
